module.exports = __webpack_public_path__ + "media/images/publish-442d07cccae8f1df16b1fdfbc720e712.png";